import * as React from "react";

function SvgCalendarScheduleDuo({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="#374151"
          d="M17.505 12.25a5.25 5.25 0 01.211 10.496l-.216.004-.216-.004A5.25 5.25 0 0112.25 17.5c0-2.849 2.407-5.254 5.255-5.25zM15 2.25a.75.75 0 01.743.648L15.75 3v.25H16a3.75 3.75 0 013.745 3.55l.005.2v3a.75.75 0 01-1.493.102L18.25 10v-.25H3.75V16a2.25 2.25 0 002.096 2.245L6 18.25h4a.75.75 0 01.102 1.493L10 19.75H6a3.75 3.75 0 01-3.745-3.55L2.25 16V7A3.75 3.75 0 015.8 3.255L6 3.25h.25V3a.75.75 0 011.493-.102L7.75 3v.25h6.5V3a.75.75 0 01.75-.75z"
        />
        <path
          fill="#98DB69"
          d="M17.503 13.75a3.75 3.75 0 013.742 3.55l.005.2-.005.2a3.752 3.752 0 01-3.35 3.53l-.196.015-.199.004-.2-.004a3.75 3.75 0 01-3.55-3.745c0-2.02 1.734-3.752 3.753-3.75zm-.11 1.483a.75.75 0 00-.75.75v1.758l.008.11a.75.75 0 00.351.53l1.382.843.09.047a.75.75 0 00.941-.296l.047-.09a.75.75 0 00-.296-.941l-1.023-.624v-1.337l-.007-.102a.75.75 0 00-.743-.648zM6.25 4.75V5l.007.102a.75.75 0 001.486 0L7.75 5v-.25h6.5V5l.007.102a.75.75 0 001.486 0L15.75 5v-.25H16l.154.005a2.25 2.25 0 012.09 2.084L18.25 7v1.25H3.75V7l.005-.154a2.25 2.25 0 012.084-2.09L6 4.75h.25z"
        />
      </g>
    </svg>
  );
}

export default SvgCalendarScheduleDuo;
